import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  model: any = {};
  loading = false;
  submitted = false;
  returnUrl: string;

  constructor(private route: ActivatedRoute,
        private router: Router) { }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  login() {

    if (this.model.username === 'opendeurne' && this.model.password === 'azerty123') {
      localStorage.setItem('username', this.model.username);
      this.router.navigate([this.returnUrl]);
    } else {
      this.model.username = '';
      this.model.password = '';
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/pages/login/login.component.ts